import React from "react";

const EditReportIcon = (props) => {
  return (
    <>
      {!props.active ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="32"
          viewBox="0 0 40 32"
          fill="none"
        >
          <rect width="40" height="32" rx="4" fill="#404040" />
          <path d="M10 21.418H30V24.7513H10V21.418Z" fill="#A5A5A5" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.584 18.9167L19.1673 7.25H20.834L25.409 18.9167H23.534L22.6006 16.4167H17.3923L16.459 18.9167H14.584ZM20.0006 9.47501L18.0173 14.75H21.984L20.0006 9.47501Z"
            fill="#A5A5A5"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="32"
          viewBox="0 0 40 32"
          fill="none"
        >
          <rect width="40" height="32" rx="4" fill="#0066FF" />
          <path d="M10 21.418H30V24.7513H10V21.418Z" fill="white" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.584 18.9167L19.1673 7.25H20.834L25.409 18.9167H23.534L22.6006 16.4167H17.3923L16.459 18.9167H14.584ZM20.0006 9.47501L18.0173 14.75H21.984L20.0006 9.47501Z"
            fill="white"
          />
        </svg>
      )}
    </>
  );
};

export default EditReportIcon;
